import React from "react";

export default function InventoryDashboard() {
  return (
    <div>
      <h2>InventoryDashboard</h2>
      <p>Coming Soon...</p>
    </div>
  );
}